import { TPicker } from '../pickerTypes';
export const openPicker = () => ({ type: TPicker.open });
export const closePicker = () => ({ type: TPicker.close });
export const togglePicker = () => ({ type: TPicker.toggle });
export const choosePickerOption = (payload) => ({ type: TPicker.onOptionClick, payload });
export const setPickerTheme = (payload) => ({ type: TPicker.setPickerTheme, payload });
